/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxfrag */

import { useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { N200 } from '@atlaskit/theme/colors';
const HeadingStyles = css({
  fontWeight: 700,
  color: `var(--ds-text-subtlest, ${N200})`,
  fontSize: '11px',
  marginBottom: "var(--ds-space-050, 4px)",
  textTransform: 'uppercase',
  marginTop: "var(--ds-space-0, 0px)",
  marginLeft: "var(--ds-space-100, 8px)"
});
export const AppRecommendationsSectionHeader = ({
  title,
  noAppsTitle = 'Discover',
  headingLevel,
  actionBus,
  mutate
}) => {
  const HeadingAs = headingLevel;
  useEffect(() => {
    const unsubscribe = actionBus === null || actionBus === void 0 ? void 0 : actionBus.on('USE_EMPTY_APPS_TITLE', () => {
      mutate(currentProps => ({
        ...currentProps,
        title: noAppsTitle
      }));
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionBus]);
  return jsx(HeadingAs, {
    "data-testid": 'discovery-sdk-component--app-recommendation-section-header',
    css: HeadingStyles
  }, title);
};
AppRecommendationsSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  noAppsTitle: PropTypes.string,
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired
};